// funcion firebase 
import { db } from './firebaseConfig';
import { collection, addDoc } from "firebase/firestore";

const EvaluacionCabDB = async ({ id_cab_inst, folio, servicio, servicionew, fecha_servicionew, tecnico, confirmado, userAdd, userMod, fechaAdd, fechaMod, emp_id }) => {

    return await addDoc(collection(db, 'evaluacioncab'), {
        id_cab_inst:id_cab_inst, 
        folio: folio,
        servicio: servicio,
        servicionew: servicionew,
        fecha_servicionew: fecha_servicionew,
        tecnico: tecnico,
        confirmado: confirmado,
        useradd: userAdd,
        usermod: userMod,
        fechaadd: fechaAdd,
        fechamod: fechaMod,
        emp_id: emp_id
    })
}

export default EvaluacionCabDB;